import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import * as S from './Ads.styles';
import { tabs } from '@/components/Profile/Ads/Ads.constants';
import { AdsEmpty } from '@/features/Profile/sections/MyAds/components/AdsEmpty/AdsEmpty';
import { AdStatus } from '@/types';
import { ROUTES } from '@/constants/routes';
import { AdCards } from '@/components/AdCards/AdCards';
import { Ad } from '@/api/types/common.types';

type Props = {
  adsLatest?: Ad[];
};

export const Ads = ({ adsLatest }: Props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const tabsRef = useRef<HTMLDivElement>(null);

  const selectedAdStatus = router.query.adStatus?.[0];

  return (
    <S.Box>
      <S.Tabs ref={tabsRef}>
        {tabs(t).map(tab => (
          <S.Tab
            key={tab.value}
            href={ROUTES.profileAds(tab.value)}
            appearance={selectedAdStatus === tab.value ? 'primary' : 'gray'}
            isRounded
          >
            {/* count will be real after BE connection */}
            {tab.name} (0)
          </S.Tab>
        ))}
      </S.Tabs>

      {selectedAdStatus === AdStatus.Published ? (
        <AdCards ads={adsLatest} hasFavorite={false} hasActions />
      ) : (
        <AdsEmpty />
      )}
    </S.Box>
  );
};
